// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { Credential } from '@daml.js/utility-credential-v0/lib/Utility/Credential/V0/Credential';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import TemplateContract from '../../../utils/TemplateContract';

const useCredentials: () => UseQueryResult<TemplateContract<Credential>[], string> = () => {
  const ledgerApi = useLedgerApiClient();

  return useQueryWithOffset({
    queryKey: ['queryCredentials'],
    queryFn: async (_, offset) => {
      return ledgerApi.queryCredentials(offset);
    },
  });
};

export default useCredentials;
